import { useAddressBookSync } from './useAddressBookSync';

/**
 * Zero-UI monitor component that runs the address-book server sync (#476) for the
 * lifetime of the app. Mount once inside UserProvider (which is already nested
 * inside ContactStateProvider), alongside SnowballSyncMonitor.
 */
const AddressBookSyncMonitor: React.FC = () => {
  useAddressBookSync();
  return null;
};

export default AddressBookSyncMonitor;
